import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, YoutubeIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
const quickLinks = [{
  label: "What's Coming",
  href: '#attractions'
}, {
  label: 'Attractions',
  href: '#attractions'
}, {
  label: 'Parties & Events',
  href: '#parties'
}, {
  label: 'Dining',
  href: '#dining'
}, {
  label: 'Location',
  href: '#contact'
}];
const socialLinks = [{
  icon: FacebookIcon,
  href: '#',
  label: 'Facebook'
}, {
  icon: InstagramIcon,
  href: '#',
  label: 'Instagram'
}, {
  icon: TwitterIcon,
  href: '#',
  label: 'Twitter'
}, {
  icon: YoutubeIcon,
  href: '#',
  label: 'YouTube'
}];
export function Footer() {
  return <footer className="bg-pulse-navy pt-16 pb-8 px-4" data-id="element-108">
      <div className="max-w-7xl mx-auto" data-id="element-109">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-110">
          {/* Brand */}
          <div data-id="element-111">
            <h2 className="text-3xl font-black text-white tracking-tight mb-2" data-id="element-112">
              PULSE
            </h2>
            <p className="text-white/60 text-sm tracking-[0.2em] uppercase mb-4" data-id="element-113">
              Entertainment Center
            </p>
            <div className="h-1 w-24 bg-gradient-to-r from-pulse-blue via-pulse-yellow to-pulse-orange rounded-full mb-6" data-id="element-114" />
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-115">
              Midlothian's premier family entertainment destination. 12
              incredible attractions under one roof. Opening 2027.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-116">
            <h3 className="text-white font-bold text-lg mb-6" data-id="element-117">Quick Links</h3>
            <ul className="space-y-3" data-id="element-118">
              {quickLinks.map(link => <li key={link.label} data-id="element-119">
                  <a href={link.href} className="text-white/70 hover:text-pulse-yellow transition-colors text-sm" data-id="element-120">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-121">
            <h3 className="text-white font-bold text-lg mb-6" data-id="element-122">Contact Info</h3>
            <ul className="space-y-4" data-id="element-123">
              <li className="flex items-start gap-3" data-id="element-124">
                <MapPinIcon className="h-5 w-5 text-pulse-blue flex-shrink-0 mt-0.5" data-id="element-125" />
                <span className="text-white/70 text-sm" data-id="element-126">
                  1234 Entertainment Blvd
                  <br data-id="element-127" />
                  Midlothian, VA 23112
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-128">
                <PhoneIcon className="h-5 w-5 text-pulse-orange flex-shrink-0" data-id="element-129" />
                <a href="tel:+18045551234" className="text-white/70 hover:text-white text-sm transition-colors" data-id="element-130">
                  (804) 555-1234
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-131">
                <MailIcon className="h-5 w-5 text-pulse-yellow flex-shrink-0" data-id="element-132" />
                <a href="mailto:info@pulseentertainment.com" className="text-white/70 hover:text-white text-sm transition-colors" data-id="element-133">
                  info@pulseentertainment.com
                </a>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          <div data-id="element-134">
            <h3 className="text-white font-bold text-lg mb-6" data-id="element-135">Follow Us</h3>
            <div className="flex gap-4" data-id="element-136">
              {socialLinks.map(social => {
              const Icon = social.icon;
              return <a key={social.label} href={social.href} aria-label={`Follow us on ${social.label}`} className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-pulse-orange transition-colors group" data-id="element-137">
                    <Icon className="h-5 w-5 text-white/70 group-hover:text-white transition-colors" data-id="element-138" />
                  </a>;
            })}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8" data-id="element-139">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-140">
            <p className="text-white/50 text-sm" data-id="element-141">
              © {new Date().getFullYear()} Pulse Entertainment Center. All
              rights reserved.
            </p>
            <div className="flex gap-6 text-sm" data-id="element-142">
              <a href="#" className="text-white/50 hover:text-white transition-colors" data-id="element-143">
                Privacy Policy
              </a>
              <a href="#" className="text-white/50 hover:text-white transition-colors" data-id="element-144">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}